import {SupportTicketAttachmentModel} from '../../model/support/support-ticket-attachment.model';
import {SupportTicketErrorTypeEnum} from '../../model/support/support-ticket-error-type.enum';
import {SupportTicketResolutionEnum} from '../../model/support/support-ticket-resolution.enum';
import {SupportTicketStatusEnum} from '../../model/support/support-ticket-status.enum';
import {SupportTicketTypeEnum} from '../../model/support/support-ticket-type.enum';
import {SupportTicketModel} from '../../model/support/support-ticket.model';
import {Searchable} from '../../state/searchable-state';
import axios from '../axios';

export namespace SupportTicketController {
  export type QuerySupportTicketsRes = {
    total: number
    available: any
    ticketIds: string[]
    items: SupportTicketModel[]
  }

  export const querySupportTickets = async (searchable: Searchable) =>
    (await axios.put<QuerySupportTicketsRes>(`/internal/support/ticket`, searchable)).data

  export const updateSupportTicketStatus = async (ticketId: string, status: SupportTicketStatusEnum, version: number) =>
    (await axios.put(`/internal/support/ticket/${ticketId}/status`, {
      status: status,
      version: version
    })).data

  export type ResolveSupportTicketReq = {
    resolution: SupportTicketResolutionEnum
    message: string
    jiraTicket: string | null
    estimatedFixDate: string | null
    status: SupportTicketStatusEnum
    classifiedType: SupportTicketTypeEnum | null
    classifiedErrorType: SupportTicketErrorTypeEnum | null
  }

  export const resolveSupportTicket = async (ticketId: string, version: number, request: ResolveSupportTicketReq)=>
    (await axios.put(`/internal/support/ticket/${ticketId}/resolution?version=${version}`, request))

  export type AnalyzeSupportTicketReq = {
    analyzeSummary: string
    analyzeEstimatedCost: number
    analyzeEstimatedDuration: number
  }

  export const analyzeSupportTicket = async (ticketId: string, version: number, request: AnalyzeSupportTicketReq)=>
    (await axios.put(`/internal/support/ticket/${ticketId}/analyze?version=${version}`, request))


  export const querySupportTicketAttachments = async (ticketId: string) =>
    (await axios.get<SupportTicketAttachmentModel[]>(`/internal/support/ticket/${ticketId}/attachments`)).data
}